/** События, за которыми следим. Предположительно они могут стриггерить лонг таск */
export const TRACKED_EVENTS = ['click', 'blur', 'focus', 'resize'] as const;
/** Тип события, за которыми следим */
export type TrackedEvent = (typeof TRACKED_EVENTS)[number];
/** Сколько последних интеракций собираем */
export const INTERACTIONS_BUFFER_LIMIT = 10;
/** Время в мс, после которого считаем, что взаимодействие пользователя и LoAF не связаны */
export const MAX_INTERACTION_DELTA = 200;
